import { combineReducers } from 'redux';
import app from './appReducer';
import paymentServiceApi from '../../state/paymentService';
import companyService from '../../state/companyService';

const rootReducer = combineReducers({
  app,
  [paymentServiceApi.reducerPath]: paymentServiceApi.reducer,
  [companyService.reducerPath]: companyService.reducer,
});
export default rootReducer;
